import type { GoogleCalendarTranslations } from '../interfaces/google-calendar';

export const googleCalendarTranslations: GoogleCalendarTranslations = {
  integrationSectionTitle: 'Google Calendar',
  integrationSectionDescription:
    'Conecta tu Google Calendar para que {{brand}} pueda leer y crear eventos por ti.',
  connectedBadge: 'Conectado',
  connectButton: 'Conectar Calendar',
  redirectDisclaimer:
    'Te redirigiremos a Google para autorizar el acceso. Puedes revocar los permisos cuando quieras.',
  configureButton: 'Configurar',
  reconnectButton: 'Reconectar',
  disconnectButton: 'Desconectar',
  openCalendarButton: 'Abrir Google Calendar',

  emailAccountLabel: 'Cuenta conectada',
  primaryCalendarLabel: 'Calendario principal',
  lastSyncLabel: 'Última sincronización',
  watchExpiresLabel: 'Canal de notificaciones expira',
  lastErrorLabel: 'Última advertencia de Google',

  drawerTitle: 'Configuración de Google Calendar',
  drawerDescription:
    'Revisa la cuenta conectada, fuerza una reconexión o desconecta {{brand}} de tu calendario.',

  disconnectDialogTitle: '¿Desconectar Google Calendar?',
  disconnectDialogDescription:
    '{{brand}} dejará de leer tus eventos. Los eventos ya sincronizados permanecerán en la base de datos hasta que los borres manualmente.',
  disconnectDialogCancel: 'Cancelar',
  disconnectDialogConfirm: 'Desconectar',

  successToast: 'Google Calendar conectado correctamente.',
  errorToast: 'No se pudo completar la conexión con Google Calendar.',
  disconnectedToast: 'Google Calendar desconectado.',

  errorTitle: 'Algo falló ({{step}})',
  retryButton: 'Reintentar',
};
